import React from 'react';
import { DropDown } from './common';
import { DuLieuHeThong } from 'api';
import {validatable} from 'components/utils';

class DropDownChonCanBoGiaiQuyet extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      coQuanQuanLyId: this.props.coQuanQuanLyId,
      vaiTro: this.props.vaiTro
    }
  }

  onChange(e) {
    this.props.onChange(e);
  }

  componentDidMount() {
    this.getCongChucPhongBan(this.state.coQuanQuanLyId);
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.coQuanQuanLyId != nextProps.coQuanQuanLyId && nextProps.coQuanQuanLyId) {
      this.setState({
        coQuanQuanLyId: nextProps.coQuanQuanLyId,
        vaiTro: nextProps.vaiTro
      });

      this.getCongChucPhongBan(nextProps.coQuanQuanLyId);
    }
  }

  getCongChucPhongBan(id) {
     let userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    let params = {
      coQuanQuanLyId: id,
      vaiTro: this.state.vaiTro,
      page: 0,
      size: 1000,
      sort: 'ten,desc'
    }
    if (this.props.vaiTro === "CHUYEN_VIEN"){
      params.vaiTro = "CHUYEN_VIEN"
    }
    if (this.props.vaiTro === "PHO_PHONG") {
      params.vaiTro = "TRUONG_PHONG"
      params.congChucHienTaiId = userInfo.id;
      params.isTruongPhong = false;
    }
    if (this.props.vaiTro === "TRUONG_PHONG") {
      params.vaiTro = "TRUONG_PHONG"
      params.isTruongPhong = true
    }
    DuLieuHeThong.actions.getChuyenVienThuocPhongBan.request(params).then(res => {
      if (this.refs.DropDownChonCanBoGiaiQuyet) {
        if (res.data._embedded) {
          this.setState({
            data: res.data._embedded.congChucs
          }, () => {
            this.props.checkCongChucPhongBan();
          });
        }
      }
    });
  }

  render() {
    return (
      <DropDown
      ref="DropDownChonCanBoGiaiQuyet"
      bindValidator={this}
      channel="formTaoDon"
      isValid={this.props.isValid}
      className={this.props.className}
      require={this.props.require}
      selectedValue={this.props.selectedValue}
      label={this.props.label}
      options={ this.state.data }
      keyName='congChucId'
      valueName='hoVaTen'
      onChange={ this.onChange.bind(this) }
      placeholder={ this.props.placeholder }
      name={this.props.name}/>
    )
  }
}

DropDownChonCanBoGiaiQuyet.defaultProps = {
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  checkCongChucPhongBan: function() {},
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  className: 'col-input',
  label: 'Công chức giải quyết',
  coQuanQuanLyId: '',
  vaiTro: 'CHUYEN_VIEN',
  name:''
}


export default validatable(DropDownChonCanBoGiaiQuyet);



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-choncanbogiaiquyet.jsx